import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ScopeService, ScopingDomain } from '@yotpo-ui/core';
import { Observable } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'yi-app', // <yi-app></yi-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent implements OnInit {

  readonly onlineChatParams = {product: 'Reviews'};
  isInstallRoute$: Observable<boolean>;

  constructor(private translate: TranslateService,
              private scopeService: ScopeService,
              private router: Router) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.scopeService.registerUrl('analytics', [ScopingDomain.AUTH]);
    this.scopeService.registerUrlToExclude('users/login', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('apps', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('v1/apps', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('v3/ugc-email-templates', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('account_system/enable_product_for_account', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('account_platform', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('invites', [ScopingDomain.AUTH]);
    this.scopeService.registerUrl('users', [ScopingDomain.AUTH]);
  }

  ngOnInit() {
    this.isInstallRoute$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url.includes('/install'))
    );
  }
}
